"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * isListener
 *
 * determines if an action is a listener on another model
 */
exports.default = (function (reducer) { return reducer.indexOf('/') > -1; });
//# sourceMappingURL=isListener.js.map